import { render } from "./MyViewOrder.vue?vue&type=template&id=faac3762"
import script from "./MyViewOrder.vue?vue&type=script&lang=js"
export * from "./MyViewOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__